// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"feb1753d","453":"0865b779","698":"8fedd067","821":"1ca75087"}[chunkId] + ".chunk.js";
};